import { clsModel, fnCreate } from '@cls/clsModel'
import { workorders as api } from '@/app/api'

////////////////////////////////////////////////////////////////////////////////////////////////////
//
// This model is a helper model which is not used for data manipulation but to
// help create an appointment for one or more employees.
// 
////////////////////////////////////////////////////////////////////////////////////////////////////

var modelName = "workorder_appointment";
const fields = [
    'id_employee', 
    'id_workorder', 
    'dt',
    'from',
    'to',
    'signed_by',
    'signature',
];

class clsEditAppointment extends clsModel {

    id_employee = null;
    id_workorder = null;
    dt = null;
    from = null;
    to = null;
    signed_by = null; 
    signature = null; 
    
    get isSigned() {
        return !!this.signed_by;
    }   

    apiLoad(id, params, extraData) {
        return this.api.loadAppointment(id);
    }
    apiSave(model) {
        return this.api.saveAppointment(model);
    }


    async doCreate(defaults) {
        throw new "Creation is not supported in this dialog";
    }

    constructor() {
        super({
          api: api,   
          modelName: modelName, 

          fillable: fields
        })
    } 
        
 }
 export default fnCreate(clsEditAppointment , 'clsEditAppointment');
